<template>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir;
  outline: none;
}

*,
*::before,
*::after {
    box-sizing: border-box;
    margin: 0;
}
</style>
